module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/bus-icon-0a0f389952e11913f6c5534f1be574b6.png";